// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import util from '@/util/'
import Element from 'element-ui'
import '@/assets/element-variables.scss'
import '@/pages/common/Header'
import '@/pages/common/MyUpload'
//import '@/pages/common/Footer' //todo: see the header

Vue.use(Element);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    if (util.isPublicRoute(to.name)) {//判断是否是不需要登录就可以访问的路由
        next()
    } else {
        if ( !window.sessionStorage.getItem('regenerate_token_flag')) {
            next()
        } else {
            if(this.isPopDialog) return;//如果为true，就不弹了
            Vue.prototype.$alert('登录超时，请重新登录！', {
                callback: action => {
                    this.isPopDialog = true;
                    let currentUrl = (window.location.href).split('?')[0];
                    next({
                        path: '/login/'+encodeURIComponent(currentUrl),
                        query: { redirect: to.fullPath }
                    })
                }
            })
        }
    }
});

Vue.prototype.$http = axios.create({
    baseURL: util.baseUrl
});
Vue.prototype.$http.interceptors.request.use( config => {//前端请求
    // 在发送请求之前做些什么，比如设置token
    config.headers.token = window.sessionStorage.getItem('token') || '';
    config.headers.refresh_token = window.sessionStorage.getItem('refresh_token') || '';
    return config;
}, error => {
    // 对请求错误做些什么
    return Promise.reject(error);
});
Vue.prototype.$http.interceptors.response.use(res => {// 后台响应
    //if(!util.isPublicRoute(app.$route.name) && ~res.data.message.indexOf('未登录')){
    //    app.$router.push(`/login?msg=${res.data.message}&redirect=${app.$route.fullPath}`)
    //}window.sessionStorage.getItem('regenerate_token_flag')
    // console.log('响应',res,res.headers.regenerate_token_flag)
    //  regenerate_token_flag 值为1，可以刷新免登录，重新赋值token，值为2，需要重新登录
    if(res.headers.token && res.headers.regenerate_token_flag != 2){
        window.sessionStorage.setItem('token',res.headers.token);
        this.isLogin = true;
    }
    if(res.headers.refresh_token && res.headers.regenerate_token_flag != 2){
        window.sessionStorage.setItem('refresh_token',res.headers.refresh_token);
        this.isLogin = true;
    }
    if(res.headers.regenerate_token_flag == 2){
        window.sessionStorage.setItem('token','');
        window.sessionStorage.setItem('refresh_token','');
        this.isLogin = false;
    }
    return res;
}, error => {
    // alert('加载失败')
    // console.log('失效',error)
   /* window.sessionStorage.setItem('token','');
    window.sessionStorage.setItem('refresh_token','');
    this.isLogin = false;*/
    return Promise.reject(error);
});
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    data: {
        activeIndex: 'home',
        isLogin: false,//判断是否是登录状态，可以通过$root.isLogin 来获取或者修改；
        uploadUrl: '', //上传接口ipa地址
        downloadUrl: '', //下载接口ipa地址
        baseUrl: '',//当前服务器地址；
        loading: false,
        isPopDialog: false,//是否可以弹出登录超时的dialog；
    },
    methods: {
        checkCompanyName(companyName,id,fn){
            let that = this;
            let url = '/v1/sSuppliers/public/isExistCompanyName?companyName='+encodeURIComponent(companyName)+'&id='+id;
            that.getHttp(url,function (res) {
                !!fn && fn(res.data);
            })
        },
        checkNumber(val){
            let that = this;
            let reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
            if(!val){
                return true;
            }else if(!reg.test(val)){
                that.$message.error('数字格式不正确！');
                return false;
            }else{
                return true;
            }
        },
        /*get或者post请求封装方法*/
        getHttp(url,successCallback){
            let that = this;
            if(url.indexOf('?') == -1){
                url = url + '?timestamp=' + new Date().getTime();
            }else{
                url = url + '&timestamp=' + new Date().getTime();
            }
            that.loading = true;
            that.$http.get(url,{
                cache: false
            }).then(res => {
                that.loading = false;
                // console.log('success,get',res)
                if(res.data.code == '1'){
                    !!successCallback && successCallback(res);
                }else{
                    // console.log('get',url)
                    that.$alert(res.data.msg,{
                        type: 'error'
                    })
                }
            }).catch(function (err) {//401,登录超时
                // console.log('catch,get',err,url);
                that.loading = false;
                if(err.response && err.response.status == '401'){
                    // console.log('get',that.isPopDialog)
                    if(that.isPopDialog) return;//如果为true，就不弹了
                    that.$alert('登录超时，请重新登录',{
                        type: 'error',
                        callback: action => {
                            that.isPopDialog = true;
                            let currentUrl = (window.location.href).split('?')[0];
                            that.$router.push('/login/'+encodeURIComponent(currentUrl));
                        }
                    })
                } else {
                    that.$alert('请求异常',{
                        type: 'error'
                    })
                }
                return;
            })
        },
        postHttp(url,data,successCallback,errorCallback){
            let that = this;
            that.loading = true;
            that.$http.post(url,data).then(res => {
                that.loading = false;
                if(res.data.code == 1){
                    // console.log('success',res)
                    !!successCallback && successCallback(res);
                }else{
                    // console.log('error',url)
                    that.$alert(res.data.msg,{
                        type: 'error',
                        callback: action => {
                            !!errorCallback && errorCallback();
                        }
                    });
                }
            }).catch(function (err) {
               // console.log('post,catch',err)
                that.loading = false;
                if(err.response && err.response.status == '401'){
                    // console.log('post',that.isPopDialog)
                    if(that.isPopDialog) return;//如果为true，就不弹了
                    that.$alert('登录超时，请重新登录',{
                        type: 'error',
                        callback: action => {
                            that.isPopDialog = true;
                            let currentUrl = (window.location.href).split('?')[0];
                            that.$router.push('/login/'+encodeURIComponent(currentUrl));
                        }
                    })
                } else {
                    that.$alert('请求异常',{
                        type: 'error'
                    })
                }
                return;
            })
        },
        /*数组去重*/
        uniqueArr(arr){
            let newArr = [];
            for(let i=0; i<arr.length; i++){
                if(newArr.indexOf(arr[i]) == -1){
                    newArr.push(arr[i]);
                }
            }
            return newArr;
        },
        /*两个数组合并去重*/
        concatArr(arr1,arr2){
            //不要直接使用var arr = arr1，这样arr只是arr1的一个引用，两者的修改会互相影响
            var arr = arr1.concat();
            //或者使用slice()复制，var arr = arr1.slice(0)
            for(var i=0;i< arr2.length;i++){
                arr.indexOf(arr2[i]) === -1 ? arr.push(arr2[i]) : 0;
            }
            return arr;
        },
        /*下载文件*/
        downloadFile(formData){
            let url = util.baseUrl+'/v1/public/download/download_direct?attachmentPath='+formData.attachPath+'&attachmentName='+encodeURIComponent(formData.attachName);
            window.location.href= url;
            // window.open(url,'_blank');
        },
        handleSelect(index){
            // console.log(index);
            this.activeIndex = index
        },
        /*判断是否是手机端-是跳转到微信*/
        goPAGE() {
            if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                window.location.href = util.wxUrl;
            }
        }
    },
    created(){
        this.uploadUrl = util.uploadUrl;
        this.downloadUrl = util.downloadUrl;
        this.baseUrl = util.baseUrl;
        this.goPAGE();
    }
});



// WEBPACK FOOTER //
// ./src/main.js